export default [
    {
        path: "/Company/Index",
        name: "CompanyIndex",
        component: () => import("@/components/Company/Index.vue"),
        meta: {
            name: "CompanyIndex",
            menuTitle: "Company",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Company/Editor",
        name: "CompanyEditor",
        component:  () => import("@/components/Company/Editor.vue"),
        meta: {
            name: "CompanyEditor",
            menuTitle: "Company",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/AppointmentMatrix/Index",
        name: "AppointmentMatrixIndex",
        component: () => import("@/components/AppointmentMatrix/Index.vue"),
        meta: {
            name: "AppointmentMatrixIndex",
            menuTitle: "Appointment Matrix",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/AppointmentMatrix/Editor",
        name: "AppointmentMatrixEditor",
        component:  () => import("@/components/AppointmentMatrix/Editor.vue"),
        meta: {
            name: "AppointmentMatrixEditor",
            menuTitle: "Appointment Matrix",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Material/Index",
        name: "MaterialIndex",
        component: () => import("@/components/Material/Index.vue"),
        meta: {
            name: "MaterialIndex",
            menuTitle: "Material",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Material/Editor",
        name: "MaterialEditor",
        component:  () => import("@/components/Material/Editor.vue"),
        meta: {
            name: "MaterialEditor",
            menuTitle: "Material",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Location/Index",
        name: "LocationIndex",
        component: () => import("@/components/Location/Index.vue"),
        meta: {
            name: "LocationIndex",
            menuTitle: "Location",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Location/Editor",
        name: "LocationEditor",
        component:  () => import("@/components/Location/Editor.vue"),
        meta: {
            name: "LocationEditor",
            menuTitle: "Location",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Freight/Index",
        name: "FreightIndex",
        component: () => import("@/components/Freight/Index.vue"),
        meta: {
            name: "Freight",
            menuTitle: "Freight",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Freight/Editor",
        name: "FreightEditor",
        component:  () => import("@/components/Freight/Editor.vue"),
        meta: {
            name: "Freight",
            menuTitle :"Freight",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Plant/Index",
        name: "PlantIndex",
        component: () => import("@/components/Plant/Index.vue"),
        meta: {
            name: "PlantIndex",
            menuTitle: "Plant",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Plant/Editor",
        name: "PlantEditor",
        component:  () => import("@/components/Plant/Editor.vue"),
        meta: {
            name: "PlantEditor",
            menuTitle: "Plant",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/PurchaseOrganization/Index",
        name: "PurchaseOrganizationIndex",
        component: () => import("@/components/PurchaseOrganization/Index.vue"),
        meta: {
            name: "PurchaseOrganizationIndex",
            menuTitle:"Purchase Organization",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/PurchaseOrganization/Editor",
        name: "PurchaseOrganizationEditor",
        component:  () => import("@/components/PurchaseOrganization/Editor.vue"),
        meta: {
            name: "PurchaseOrganizationEditor",
            menuTitle: "Purchase Organization",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/SalesOrganization/Index",
        name: "SalesOrganizationIndex",
        component: () => import("@/components/SalesOrganization/Index.vue"),
        meta: {
            name: "SalesOrganizationIndex",
            menuTitle: "Sales Organization",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/SalesOrganization/Editor",
        name: "SalesOrganizationEditor",
        component:  () => import("@/components/SalesOrganization/Editor.vue"),
        meta: {
            name: "SalesOrganizationEditor",
            menuTitle: "Sales Organization",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/ProductCategory/Index",
        name: "ProductCategoryIndex",
        component: () => import("@/components/ProductCategory/Index.vue"),
        meta: {
            name: "ProductCategoryIndex",
            menuTitle: "Product Category",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/ProductCategory/Editor",
        name: "ProductCategoryEditor",
        component:  () => import("@/components/ProductCategory/Editor.vue"),
        meta: {
            name: "ProductCategoryEditor",
            menuTitle: "Product Category",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/TruckType/Index",
        name: "TruckTypeIndex",
        component: () => import("@/components/TruckType/Index.vue"),
        meta: {
            name: "TruckTypeIndex",
            menuTitle: "Truck Type",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/TruckType/Editor",
        name: "TruckTypeEditor",
        component:  () => import("@/components/TruckType/Editor.vue"),
        meta: {
            name: "TruckTypeEditor",
            menuTitle: "Truck Type",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Transporter/:type",
        name: "Transporter",
        component:  () => import("@/components/Transporter/Index.vue"),
        meta: {
            name: "TransporterIndex",
            menuTitle: "Transporter",
            requiresAuth:true
        },
        props:true
    },
    // {
    //     path: "/Transporter/Index/:",
    //     name: "TransporterMaster",
    //     component:  () => import("@/components/Transporter/Index.vue"),
    //     meta: {
    //         name: "TransporterMaster",
    //         menuTitle: "Transporter (Internal) Master",
    //         requiresAuth:true
    //     },
    //     props:true
    // },
    {
        path: "/Transporter/Editor",
        name: "TransporterEditor",
        component:  () => import("@/components/Transporter/Editor.vue"),
        meta: {
            name: "TransporterEditor",
            menuTitle: "Transporter",
            requiresAuth:true
        },
        props:true
    },
    {
        path: "/Incoterms/Index",
        name: "IncotermsIndex",
        component: () => import("@/components/Incoterms/Index.vue"),
        meta: {
            name: "IncotermsIndex",
            menuTitle: "Incoterms",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Incoterms/Editor",
        name: "IncotermsEditor",
        component:  () => import("@/components/Incoterms/Editor.vue"),
        meta: {
            name: "IncotermsEditor",
            menuTitle: "Incoterms",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Lookup/Index",
        name: "LookupIndex",
        component: () => import("@/components/Lookup/Index.vue"),
        meta: {
            name: "LookupIndex",
            menuTitle: "Lookup",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Lookup/Editor",
        name: "LookupEditor",
        component:  () => import("@/components/Lookup/Editor.vue"),
        meta: {
            name: "LookupEditor",
            menuTitle: "Lookup",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/User/Index",
        name: "UserIndex",
        component: () => import("@/components/User/Index.vue"),
        meta: {
            name: "UserIndex",
            menuTitle: "User",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/User/Editor",
        name: "UserEditor",
        component:  () => import("@/components/User/Editor.vue"),
        meta: {
            name: "UserEditor",
            menuTitle: "User",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Group/Index",
        name: "GroupIndex",
        component: () => import("@/components/Group/Index.vue"),
        meta: {
            name: "GroupIndex",
            menuTitle: "Group",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Group/Editor",
        name: "GroupEditor",
        component:  () => import("@/components/Group/Editor.vue"),
        meta: {
            name: "GroupEditor",
            menuTitle: "Group",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Factory/Index",
        name: "FactoryIndex",
        component: () => import("@/components/Factory/Index.vue"),
        meta: {
            name: "FactoryIndex",
            menuTitle: "Factory",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Factory/Editor",
        name: "FactoryEditor",
        component:  () => import("@/components/Factory/Editor.vue"),
        meta: {
            name: "FactoryEditor",
            menuTitle: "Factory",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/MaterialConversion/Index",
        name: "MaterialConversionIndex",
        component: () => import("@/components/MaterialConversion/Index.vue"),
        meta: {
            name: "Material Conversion",
            menuTitle: "Material Conversion",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/MaterialConversion/Editor",
        name: "MaterialConversionEditor",
        component:  () => import("@/components/MaterialConversion/Editor.vue"),
        meta: {
            name: "Material Conversion",
            menuTitle: "Material Conversion",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Vendor/Index",
        name: "VendorIndex",
        component: () => import("@/components/Vendor/Index.vue"),
        meta: {
            name: "VendorIndex",
            menuTitle: "Vendor",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Vendor/Editor",
        name: "VendorEditor",
        component:  () => import("@/components/Vendor/Editor.vue"),
        meta: {
            name: "VendorEditor",
            menuTitle: "Vendor",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Customer/Index",
        name: "CustomerIndex",
        component: () => import("@/components/Customer/Index.vue"),
        meta: {
            name: "CustomerIndex",
            menuTitle: "Customer",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Customer/Editor",
        name: "CustomerEditor",
        component:  () => import("@/components/Customer/Editor.vue"),
        meta: {
            name: "CustomerEditor",
            menuTitle: "Customer",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/TransporterQuota/Index",
        name: "TransporterQuotaIndex",
        component: () => import("@/components/TransporterQuota/Index.vue"),
        meta: {
            name: "TransporterQuotaIndex",
            menuTitle: "Transporter Quota",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/TransporterQuota/Editor",
        name: "TransporterQuotaEditor",
        component:  () => import("@/components/TransporterQuota/Editor.vue"),
        meta: {
            name: "TransporterQuotaEditor",
            menuTitle: "Transporter Quota",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/ApprovalMatrix/Index",
        name: "ApprovalMatrixIndex",
        component: () => import("@/components/ApprovalMatrix/Index.vue"),
        meta: {
            name: "ApprovalMatrixIndex",
            menuTitle: "Approval Matrix",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/ApprovalMatrix/Editor",
        name: "ApprovalMatrixEditor",
        component:  () => import("@/components/ApprovalMatrix/Editor.vue"),
        meta: {
            name: "ApprovalMatrixEditor",
            menuTitle: "Approval Matrix",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/RunningNumber/Index",
        name: "RunningNumberIndex",
        component: () => import("@/components/RunningNumber/Index.vue"),
        meta: {
            name: "RunningNumberIndex",
            menuTitle: "Running Number",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/RunningNumber/Editor",
        name: "RunningNumberEditor",
        component:  () => import("@/components/RunningNumber/Editor.vue"),
        meta: {
            name: "RunningNumberEditor",
            menuTitle: "Running Number",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/AutoRejectSetting/Index",
        name: "AutoRejectSettingIndex",
        component: () => import("@/components/AutoRejectSetting/Index.vue"),
        meta: {
            name: "AutoRejectSettingIndex",
            menuTitle: "Auto Reject Setting",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/AutoRejectSetting/Editor",
        name: "AutoRejectSettingEditor",
        component:  () => import("@/components/AutoRejectSetting/Editor.vue"),
        meta: {
            name: "AutoRejectSettingEditor",
            menuTitle: "Auto Reject Setting",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/PODRequirement/Index",
        name: "PODRequirementIndex",
        component: () => import("@/components/PODRequirement/Index.vue"),
        meta: {
            name: "PODRequirementIndex",
            menuTitle: "POD Requirement",
        },
        props: true
    },
    {
        path: "/ConditionType/Index",
        name: "ConditionTypeIndex",
        component: () => import("@/components/ConditionType/Index.vue"),
        meta: {
            name: "ConditionTypeIndex",
            menuTitle: "Condition Type",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/PODRequirement/Editor",
        name: "PODRequirementEditor",
        component:  () => import("@/components/PODRequirement/Editor.vue"),
        meta: {
            name: "PODRequirementEditor",
            menuTitle: "POD Requirement",
        },
        props: true
    },
    {
        path: "/ConditionType/Editor",
        name: "ConditionTypeEditor",
        component:  () => import("@/components/ConditionType/Editor.vue"),
        meta: {
            name: "ConditionTypeEditor",
            menuTitle: "Condition Type",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/AppointmentRequirement/Index",
        name: "AppointmentRequirementIndex",
        component: () => import("@/components/AppointmentRequirement/Index.vue"),
        meta: {
            name: "AppointmentRequirementIndex",
            menuTitle: "Appointment Requirement",
        },
        props: true
    },
    {
        path: "/FRCTerm/Index",
        name: "FRCTermIndex",
        component: () => import("@/components/FRCTerm/Index.vue"),
        meta: {
            name: "FRCTermIndex",
            menuTitle: "Terms of FRC",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/AppointmentRequirement/Editor",
        name: "AppointmentRequirementEditor",
        component:  () => import("@/components/AppointmentRequirement/Editor.vue"),
        meta: {
            name: "AppointmentRequirementEditor",
            menuTitle: "Appointment Requirement",
        },
        props: true
    },
    {
        path: "/FRCTerm/Editor",
        name: "FRCTermEditor",
        component:  () => import("@/components/FRCTerm/Editor.vue"),
        meta: {
            name: "FRCTermEditor",
            menuTitle: "Terms of FRC",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Service/Index",
        name: "ServiceIndex",
        component: () => import("@/components/Service/Index.vue"),
        meta: {
            name: "ServiceIndex",
            menuTitle: "Service",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Service/Editor",
        name: "ServiceEditor",
        component:  () => import("@/components/Service/Editor.vue"),
        meta: {
            name: "ServiceEditor",
            menuTitle: "Service",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/QuantityTerm/Index",
        name: "QuantityTermIndex",
        component: () => import("@/components/QuantityTerm/Index.vue"),
        meta: {
            name: "QuantityTermIndex",
            menuTitle: "Quantity Terms",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/QuantityTerm/Editor",
        name: "QuantityTermEditor",
        component:  () => import("@/components/QuantityTerm/Editor.vue"),
        meta: {
            name: "QuantityTermEditor",
            menuTitle: "Quantity Terms",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/PurchaseGroup/Index",
        name: "PurchaseGroupIndex",
        component: () => import("@/components/PurchaseGroup/Index.vue"),
        meta: {
            name: "PurchaseGroupIndex",
            menuTitle: "Purchase Group",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/PurchaseGroup/Editor",
        name: "PurchaseGroupEditor",
        component:  () => import("@/components/PurchaseGroup/Editor.vue"),
        meta: {
            name: "PurchaseGroupEditor",
            menuTitle: "Purchase Group",
            requiresAuth: true
        },
        props: true
    },
    
    {
        path: "/PICContract/Index",
        name: "PICContractIndex",
        component: () => import("@/components/PICContract/Index.vue"),
        meta: {
            name: "PICContractIndex",
            menuTitle: "PIC Contract",
            requiresAuth: true
        },
        props: true
    },
    // {
    //     path: "/Vessel/Index",
    //     name: "VesselIndex",
    //     component: () => import("@/components/Vessel/Index.vue"),
    //     meta: {
    //         name: "VesselIndex",
    //         menuTitle: "Vessel",
    //     },
    //     props: true
    // },
    // {
    //     path: "/Vessel/Editor",
    //     name: "VesselEditor",
    //     component:  () => import("@/components/Vessel/Editor.vue"),
    //     meta: {
    //         name: "VesselEditor",
    //         menuTitle: "Vessel",
    //     },
    //     props: true
    // },
    {
        path: "/PICContract/Editor",
        name: "PICContractEditor",
        component:  () => import("@/components/PICContract/Editor.vue"),
        meta: {
            name: "PICContractEditor",
            menuTitle: "PIC Contract",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/IncotermRule/Index",
        name: "IncotermRuleIndex",
        component: () => import("@/components/IncotermRule/Index.vue"),
        meta: {
            name: "IncotermRuleIndex",
            menuTitle: "Incoterm Rule",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/IncotermRule/Editor",
        name: "IncotermRuleEditor",
        component:  () => import("@/components/IncotermRule/Editor.vue"),
        meta: {
            name: "IncotermRuleEditor",
            menuTitle: "Incoterm Rule",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/VATRegulation/Index",
        name: "VATRegulationIndex",
        component: () => import("@/components/VATRegulation/Index.vue"),
        meta: {
            name: "VATRegulationIndex",
            menuTitle: "VAT Regulation",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/VATRegulation/Editor",
        name: "VATRegulationEditor",
        component:  () => import("@/components/VATRegulation/Editor.vue"),
        meta: {
            name: "VATRegulationEditor",
            menuTitle: "VAT Regulation",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Route/Index",
        name: "RouteIndex",
        component: () => import("@/components/Route/Index.vue"),
        meta: {
            name: "RouteIndex",
            menuTitle: "Route",
            requiresAuth: true
        },
        props: true
    },
    {
        path: "/Route/Editor",
        name: "RouteEditor",
        component:  () => import("@/components/Route/Editor.vue"),
        meta: {
            name: "RouteEditor",
            menuTitle: "Route",
            requiresAuth: true
        },
        props: true
    },
]   